/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image-add-circle-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>photograph plus create new</desc><g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M17.25 11.25a6 6 0 100 12 6 6 0 100-12zM17.25 14.25v6M14.25 17.25h6"/><path pid="1" d="M8.25 20.25H2.24a1.51 1.51 0 01-1.5-1.5s0 0 0 0V2.25h0C.73 1.42 1.41.74 2.23.74h10.62l-.01-.001c.39 0 .77.15 1.06.43l2.872 2.87h0c.28.28.43.66.43 1.06v3.12"/><path pid="2" d="M5.25 5.62h-.01c.2-.01.37.16.37.37 0 .2-.17.37-.38.37s-.38-.17-.38-.38h0c-.01-.21.16-.38.37-.38M12.279 9.9L11.25 8.25l-.01-.01a.746.746 0 00-1.04-.21c-.08.05-.15.11-.2.19l-2 2.85-1.24-.99h0a.758.758 0 00-1.06.11c-.02.01-.03.03-.04.05l-1.94 3.98h4.5"/></g>'
  }
})
